// extracted by mini-css-extract-plugin
export const sectionTwoColumnTileLarge = "twoColumnTileLarge-module--sectionTwoColumnTileLarge--2FaHG";
export const sectionContainer = "twoColumnTileLarge-module--sectionContainer--MQiBL";
export const flexWrap = "twoColumnTileLarge-module--flexWrap--3oh6C";
export const itemWrap = "twoColumnTileLarge-module--itemWrap--3mfP1";
export const itemBg = "twoColumnTileLarge-module--itemBg--3xH_4";
export const itemContent = "twoColumnTileLarge-module--itemContent--3uCgq";
export const alternateStyle = "twoColumnTileLarge-module--alternateStyle--CEecr";